import React from 'react';
import { Link } from 'react-router'
import PropTypes from 'prop-types';
import logo from '../../../images/fatemi.png'

const Logo = props => {
  const {
    title,
    isOpen,
  } = props

  return (
    <Link to="/" id="logo-container">
      <img src={logo} alt={title}/>
      {isOpen &&
        <span>
          {title}
        </span>
      }
    </Link>
  );
};

Logo.PropTypes = {
  title: PropTypes.string.isRequired,
  isOpen: PropTypes.bool
}

Logo.defaultProps = {
  title: 'سامانه آموزشی مبنا',
  isOpen: true,
}

export default Logo;


// WEBPACK FOOTER //
// ./src/components/common/Logo/Index.js